import React from 'react';
import { Button, Form, Spinner, Table } from 'react-bootstrap';

const JianyingOrderPicker = ({
  eligibleOrders,
  filter,
  loading,
  message,
  onChoose,
  onFilterChange,
  orderCount,
  orderId,
}) => {
  return (
    <section className="jianying-order-picker">
      <div className="jianying-order-picker__toolbar">
        <div>
          <span>{orderCount} 个订单可制作</span>
        </div>
        <Form.Control
          type="search"
          value={filter}
          onChange={(event) => onFilterChange(event.target.value)}
          placeholder="筛选客户、订单号或视频类型"
          aria-label="筛选可制作订单"
        />
      </div>
      {message ? <p className="jianying-notice" role="alert">{message}</p> : null}
      <div className="jianying-order-picker__table">
        <Table hover responsive={false}>
          <thead>
            <tr>
              <th>客户</th>
              <th>订单号</th>
              <th>视频类型</th>
              <th>仪式时间</th>
              <th className="text-end">操作</th>
            </tr>
          </thead>
          <tbody>
            {eligibleOrders.map((order) => {
              const selected = String(order.client_id) === String(orderId);
              return (
                <tr key={order.client_id} className={selected ? 'is-selected' : ''}>
                  <td><strong>{order.client_name || '-'}</strong></td>
                  <td>{order.client_id}</td>
                  <td>{order.video_type || order.video_type_id || '-'}</td>
                  <td>
                    {order.ceremony_date
                      ? new Date(order.ceremony_date).toLocaleString('zh-CN')
                      : '-'}
                  </td>
                  <td className="text-end">
                    <Button
                      size="sm"
                      variant={selected ? 'success' : 'outline-primary'}
                      disabled={selected || loading}
                      onClick={() => onChoose(order.client_id)}
                    >
                      {selected ? '已选择' : '选择'}
                    </Button>
                  </td>
                </tr>
              );
            })}
            {!loading && eligibleOrders.length === 0 ? (
              <tr><td colSpan="5" className="jianying-empty">暂无符合条件的订单</td></tr>
            ) : null}
            {loading ? (
              <tr>
                <td colSpan="5" className="jianying-empty">
                  <Spinner animation="border" size="sm" /> 正在读取订单
                </td>
              </tr>
            ) : null}
          </tbody>
        </Table>
      </div>
    </section>
  );
};

export default JianyingOrderPicker;
